module.exports = __webpack_public_path__ + "static/media/TotalDevices.5e73012a.png";